<section class="banner_part">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-xl-6">
                <div class="banner_text">
                    <div class="banner_text_iner">
                        <!--<h5>Every child yearns to learn</h5>-->
                        <h1>Bridging the Digital divide in Education</h1>
                        <p>The primary objective of BalaSwecha is to bridge the growing digital divide in education between privileged and underprivileged in India. Schools for the underprivileged in India, for example the government schools, face a lot of problems including lack of continuous electricity, infrastructure and personnel.</p>
                        <!-- <a href="#" class="btn_1">Browse all Simulations </a> -->
                        <a routerLink="/simulations" (click)="onClickOnSubj('all')" class="btn_2">Browse all Simulations </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="feature_part">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-xl-3" (click)="onClickOnSubj(item.type)" *ngFor="let item of subjects">
                <div class="single_feature" >
                    <div class="single_feature_part">
                        <span class="single_feature_icon"><img [src]="item.img" height="60px" width="60px"></span>
                        <h4>{{item.value}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- <section class="learning_part">
    <div class="container">
        <div class="row align-items-sm-center align-items-lg-stretch">
            <div class="col-md-7 col-lg-7">
                <div class="learning_img">
                    <img src="../../../assets/images/static/learning_img.png" alt="">
                </div>
            </div>
            <div class="col-md-5 col-lg-5">
                <div class="learning_member_text">
                    <h5>About us</h5>
                    <h2>Learning with Love
                        and Laughter</h2>
                    <p>Fifth saying upon divide divide rule for deep their female all hath brind Days and beast
                        greater grass signs abundantly have greater also
                        days years under brought moveth.</p>
                    <ul>
                        <li><span class="ti-pencil-alt"></span>Him lights given i heaven second yielding seas
                            gathered wear</li>
                        <li><span class="ti-ruler-pencil"></span>Fly female them whales fly them day deep given
                            night.</li>
                    </ul>
                    <a href="#" class="btn_1">Read More</a>
                </div>
            </div>
        </div>
    </div>
</section> -->
